import { SpecialSymbolGroup } from '@cgs/data-access';
import { DefaultSpecGroupDto } from '../../models';

export function defaultSpecGroupMapper(items: DefaultSpecGroupDto[]): SpecialSymbolGroup[] {
  return items.map((item) => {
    const symbol = new SpecialSymbolGroup();
    symbol.positions = item.positions;
    symbol.positions2d = item.positions2d;
    symbol.positionsWin = item.positionsWin;
    symbol.previousPositions = null;
    symbol.type = item.type;
    symbol.subType = item.subType;
    symbol.totalJackPotWin =
      typeof item.totalWinDouble === 'number' ? item.totalWinDouble : item.totalWin!;
    symbol.totalWinDouble = item.totalWinDouble;
    symbol.symbolId = item.symbolId;
    symbol.previousSymbolId = item.previousSymbolId;
    symbol.collectCount = item.collectCount;
    symbol.totalWin = item.totalWin;
    return symbol;
  });
}
